import type { SvgIconProps } from './types';

export function BiListCheck(props: SvgIconProps) {
  return (
    <svg stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 19 19" height="1em" width="1em" {...props}>
      <path d="M4 7H15V9H4zM4 11H15V13H4zM4 15H11V17H4zM19.299 12.292L14.999 16.583 13.707 15.292 12.293 16.707 14.999 19.411 20.711 13.708z" />
    </svg>
  );
}
